import React from 'react'
import ServiceTemplate from '../../components/ServiceTemplate'
import { Settings, CheckCircle, Users, Rocket } from 'lucide-react'

const OdooImplementation = () => {
  const features = [
    {
      icon: <Settings className="w-6 h-6" data-component-path="client/src/pages/services/OdooImplementation.jsx" data-component-line="7:12" data-component-id="client/src/pages/services/OdooImplementation.jsx:7:12" />,
      title: 'Full Setup',
      description: 'Complete Odoo deployment and configuration'
    },
    {
      icon: <CheckCircle className="w-6 h-6" data-component-path="client/src/pages/services/OdooImplementation.jsx" data-component-line="13:12" data-component-id="client/src/pages/services/OdooImplementation.jsx:13:12" />,
      title: 'Best Practices',
      description: 'Industry-proven implementation methodology'
    },
    {
      icon: <Users className="w-6 h-6" data-component-path="client/src/pages/services/OdooImplementation.jsx" data-component-line="19:12" data-component-id="client/src/pages/services/OdooImplementation.jsx:19:12" />,
      title: 'User Training',
      description: 'Comprehensive team onboarding programs'
    },
    {
      icon: <Rocket className="w-6 h-6" data-component-path="client/src/pages/services/OdooImplementation.jsx" data-component-line="25:12" data-component-id="client/src/pages/services/OdooImplementation.jsx:25:12" />,
      title: 'Go-Live Support',
      description: 'Dedicated assistance during launch phase'
    },
  ]

  return (
    <ServiceTemplate
      title="Odoo Implementation"
      subtitle="Expert deployment of Odoo ERP tailored to your business processes"
      description="As an Official Odoo Partner, we deliver seamless implementations that transform your operations. From initial planning to go-live support, our certified experts ensure your Odoo system is configured perfectly for your unique needs."
      features={features}
      heroImage="https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=1920"
    />
  )
}

export default OdooImplementation